import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const CmsPostPageBodyHeaderBreadcrumbsHolder = styled.div`
  flex: 3;
  margin-bottom: 24px;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    flex: 1;
  }
`;
